<template>
  <div class="mainContainer">
    <div class="fixedHeroVideo">
        <home-hero :sectionDataIndex="0"></home-hero>
    </div>
    <main v-if="siteReady" id="mainScroller" class="mainContent">
      <section class="siteSection transparentSection">
        &nbsp; <!--empty transparent section for the video bg-->
      </section>
      <section class="siteSection heroText">
        <home-hero-text :sectionDataIndex="0"></home-hero-text>
      </section>
      <section class="siteSection secBgGray2" style="display:none;">
        <home-benefits :sectionDataIndex="1"></home-benefits>
      </section>
      <section class="siteSection secBgWhite">
        <implant-range :sectionDataIndex="2"></implant-range>
      </section>
      <section class="siteSection secBgGray2">
        <tech-info :sectionDataIndex="3"></tech-info>
      </section>
      <section class="siteSection secBgWhite">
        <drilling-protocols :sectionDataIndex="4"></drilling-protocols>
      </section>
      <section class="siteSection">
        <coverscrews :sectionDataIndex="5"></coverscrews>
      </section>
      <section class="siteSection kit">
        <lance-kit :sectionDataIndex="6"></lance-kit>
      </section>
      <section class="siteSection secBgGray1">
        <insertion-options :sectionDataIndex="7"></insertion-options>
      </section>
      <section class="siteSection">
        <packaging :sectionDataIndex="8"></packaging>
      </section>
      <section class="siteSection secBgWhite">
        <prosthetic :sectionDataIndex="9"></prosthetic>
      </section>
      <section class="siteSection footer">
        <app-footer></app-footer>
      </section>
    </main>
  </div>
</template>

<script>
  import HomeHero           from "@/views/lance/LanceHero.vue";
  import HomeHeroText       from "@/views/lance/LanceHeroText.vue";
  //import HomeBenefits       from "@/views/lance/LanceBenefits.vue";
  import HomeBenefits         from "@/views/lance/Benefits.vue";
  import ImplantRange       from "@/views/lance/LanceImplantRange.vue";
  import DrillingProtocols  from "@/views/lance/LanceDrillingProtocols.vue";
  import TechInfo           from "@/views/lance/LanceTechInfo.vue";
  import InsertionOptions   from "@/views/lance/LanceInsertionOptions.vue";
  import Packaging          from "@/views/lance/LancePackaging.vue";  
  import Coverscrews        from "@/views/lance/LanceCoverscrews.vue";  
  import Prosthetic         from "@/views/lance/LanceProsthetic.vue";  
  import LanceKit           from "@/views/lance/LanceKit.vue";  
  import AppFooter          from "@/views/lance/AppFooter.vue";    
  
  import { mapActions, mapState } from "vuex";
  
  export default 
  {
    data(){
      return{
        site_data:null
      }
    },
    components:
    {
      HomeHero,
      HomeHeroText,
      HomeBenefits,
      ImplantRange,
      DrillingProtocols,
      TechInfo,
      InsertionOptions,
      Packaging,
      Coverscrews,
      Prosthetic,
      LanceKit,
      AppFooter
    }, 
    computed: {
    ...mapState(["siteData","siteDataReady","siteReady","siteVisibleSection"]),
  },
  methods: {
    ...mapActions(["xSetPlatform","loadSiteData","setSiteReady","setVisibleSection"]),
    
    onSectionVisible(domSectionIndex)
    {
        var vm=this;
        let sectionIndex = domSectionIndex;
        let sectionDataIndex = sectionIndex;
        if(sectionIndex>0){
          sectionDataIndex--;//!important because the dom 1st section is empty section
        }
        var secData =  this.siteData.SECTIONS[sectionDataIndex];
        
        //PLAY/PAUSE VIDEO ACCORDING TO THE SCROLL POSITION
        var vid = document.getElementById("videoBgHero");
        if(domSectionIndex>2){
          vid.pause();//pause video when hero is hidden
          //when scrolling to section 2 (ImplantRange) or futher, by defult select the 3.75 platform
          setTimeout(() => {
            vm.xSetPlatform(1);  
          }, 1800);
        }else{
          vid.play();//resume video when hero is visible
        }
        if(secData.section=='benefits')
        {
          //the scroller on benefits is hidden becuase it's stopping the site from scrolling the hero to the benefits
          //when revealing the 'benefits' section set timeout for 1 sec and show the benfits scroller
          //imgBnScroller1 add 'show' class after 1 sec
          setTimeout(() => {
            var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
            imgBnScroller1.classList.add("show");//(display block)           
          }, 1100);
          setTimeout(() => {
            var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
            imgBnScroller1.classList.add("showOpaq"); //remove opacity            
          }, 1300);
        }        
        if(secData.section == 'surgical_kit'){
          var kitVideo = document.getElementById("kitVideo");
          kitVideo.play();//start kit video 
        }
    }
    },
    watch: 
    { 
      '$store.state.siteVisibleSection': function() 
      {
        var vm = this;
        let _siteVisibleSection = this.$store.state.siteVisibleSection;
        vm.onSectionVisible(_siteVisibleSection);
      }
    }   
  }
</script>
